import { Logout } from "rest/requests";
import swal from "sweetalert";

export const logoutRequest = (navigate) => {
  Logout()
    .then(() => {
      console.log("ok");
      localStorage.removeItem("userData");
      navigate("/Login", { replace: true });
    })
    .catch((e) => {
      console.log("error", e);
      swal(
        "Error saliendo al sistema",
        "Un inesperado error a ocurrido. Usted continua dentro del sistema",
        "error"
      );
    });
};
